export function maskToken(value: string): string {
  return value.length > 5 ? value.slice(0, 5) + '*'.repeat(value.length - 5) : value;
}